import React, { useState } from 'react';
import DealerForm from './DealerForm';
import DealerResults from './DealerResults';
import { PageContainer } from '../general/Styles.jsx';
import Loader from '../general/Loader';
import useDataFromDom from '../../hooks/useDataFromDom';
import { styled } from 'styled-components';
import useContentful from "../../hooks/useContentful";
import contentfulComponentLoop from "../../lib/contentfulComponentLoop";
import { ModalContextProvider } from "../../contexts/ModalContext";
import getContentfulLocale from "../../lib/getContentfulLocale";
import useBrand from '../../hooks/useBrand';

const ContainerTwo = styled.div`
  margin-top: 36px;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;

  ${({ $brand }) => $brand == 'jackson' && `
    margin-top: 0;
    background: #F1F1F1;
    width: 100vw;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  `}
`;

const DealerLocator = (page) => {
  const [results, setResults] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [input, setInput] = useState('');
  const [data, setData] = useState('');
  const [buyCodeGroups, setBuyCodeGroups] = useState([]);
  const brand = useBrand();
  const { 
    brandKey, 
    buyLocalBrandKey, 
    brandID, 
    buyLocalBrandId, 
    apiUrl, 
    country, 
    site, 
    searchRadius, 
    distanceUnit, 
    sku, 
    buyCodeUrl, 
    enableResultsCategories,
    shopLocale,
    shopMarket
  } = useDataFromDom(['data-react'], 'dealer-locator-react-data');

  const locale = getContentfulLocale(shopLocale, shopMarket);
  const contentfulDiv = document.getElementById('contentful');
  let contentfulData;
  if(contentfulDiv){
    const entryId = contentfulDiv?.dataset.entryId;
    if(entryId){
      ({ contentfulData } = useContentful({ include: 10, 'sys.id': entryId, locale }));
    }
  }

  window.google = window.google || {};
  google.maps = google.maps || {};
  let buyCodeGroupsData = [];
  let center = {};
  
  const search = q => {
    setInput(q);
    setError(false);
    setResults([]);
    setLoading(true);
    try {
      if (q === 'my location') {
        navigator.geolocation.getCurrentPosition(function(position) {
          if (position.coords.latitude && position.coords.longitude) {
            center.latitude = position.coords.latitude;
            center.longitude = position.coords.longitude;
            searchDealer();
          } else {
            setError(true);
            setResults([]);
            setLoading(false);
            return;
          }
        });
      } else {
        let geocoderSearch = { address: q };
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode(geocoderSearch, function(results, status) {
          if (results && results[0] && results[0].geometry && results[0].geometry.location) {
            let result = results[0].geometry.location.toJSON();
            center.latitude = result.lat;
            center.longitude = result.lng;
            searchDealer();
          } else {
            setError(true);
            setResults([]);
            setLoading(false);
            return;
          }
        });
      }
    } catch (e) {
      console.log(e);
      setError(true);
      setResults([]);
      setLoading(false);
      return;
    }
  };
  const searchDealer = () => {
    try {
      let data = {
        brand: brandKey,
        country: country,
        distanceUnit: distanceUnit,
        radius: JSON.parse(searchRadius),
        center: center
      };
      if (page && page.page && page.page === 'pdp' && buyLocalBrandKey && buyLocalBrandKey.length && buyLocalBrandKey != 'null') {
        data.brand = buyLocalBrandKey;
      }
      if (page && page.page && page.page === 'pdp' && sku && sku.length && sku != 'null') {
        data.sku = sku;
      }
      if (buyCodeGroupsData && buyCodeGroupsData.length) {
        data.groups = buyCodeGroupsData;
      }
      setData(data);
    //  console.log('post data', data);
      const postData = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      };
      fetch(apiUrl, postData)
        .then(res => res.json())
        .then(data => {
          console.log('response data', data);
          if (data.data && data.data.results && data.data.results.length) {
            setResults(data.data.results);
            setError(false);
            if (buyCodeUrl && buyCodeUrl.length && page && page.page && page.page === 'dealers') {
              getBuyCodeGroups();
            } else {
              setLoading(false);
            }
            return;
          } else {
            setError(true);
            setResults([]);
            setLoading(false);
            return;
          }
        })
        .catch(error => {
          console.log('error', error);
          if (error.response) {
            console.log('error.response', error.response);
            console.log('error.response.data', error.response.data);
            console.log('error.response.status', error.response.status);
            console.log('error.response.headers', error.response.headers);
          }
          if (error.request) {
            console.log('error.request', error.request);
          }
          if (error.message) {
            console.log('error.message', error.message);
          }
          if (error.config) {
            console.log('error.config', error.config);
          }
          setError(true);
          setResults([]);
          setLoading(false);
          return;
        });
    } catch (e) {
      console.log(e);
      setError(true);
      setResults([]);
      setLoading(false);
      return;
    }
  };
  const back = () => {
    setResults([]);
    setError(false);
    setLoading(false);
  };
  const getBuyCodeGroups = () => {
    try {
      fetch(buyCodeUrl)
        .then(res => res.json())
        .then(data => {
          console.log('buy code groups response data', data);
          if (data.data && data.data.buyCodesGroups) {
            let newData = marshallData(data.data.buyCodesGroups);
            console.log('buy code groups', newData);
            setBuyCodeGroups(newData);
            setLoading(false);
          } else {
            setBuyCodeGroups([]);
            setLoading(false);
            return;
          }
        });
    } catch (e) {
      console.log(e);
      setBuyCodeGroups([]);
      setError(true);
      setLoading(false);
      return;
    }
  };
  const marshallData = dataArray => {
    var dataKeys = Object.keys(dataArray);
    var i;
    var dataKey;
    var marshalledData = [];
    for (i = 0; i < dataKeys.length; i += 1) {
      dataKey = dataKeys[i];
      marshalledData.push(dataArray[dataKey]);
    }
    return marshalledData;
  };
  const searchCategory = (category, input, groups) => {
    if (groups && groups.length) {
      buyCodeGroupsData = groups;
    }
    if (buyCodeGroupsData.indexOf(category) > -1) {
      buyCodeGroupsData.splice(buyCodeGroupsData.indexOf(category), 1);
    } else {
      buyCodeGroupsData.push(category);
    }
    search(input);
  };
  return (
    <>
      <PageContainer id="dealer-finder" className="container" $brand={brand}>
        {loading ? (
          <Loader />
        ) : results && results.length ? (
          <DealerResults results={results} back={back} input={input} data={data} radius={searchRadius} site={site} buyCodeGroups={buyCodeGroups} pagex={page.page} searchCategory={searchCategory} enableResultsCategories={enableResultsCategories} />
        ) : (
          <DealerForm search={search} error={error} site={site ? site : 'null'} />
        )}

      {!loading && !results.length && contentfulData && page && page.page && page.page === 'dealers' && (
            <ModalContextProvider>
              <ContainerTwo $brand={brand} >
                {contentfulComponentLoop(contentfulData.items[0].fields.components, { locale })}
              </ContainerTwo>
            </ModalContextProvider>
          )}

      </PageContainer>
    </>
  );
};
export default DealerLocator;
